type ConfigWithChannel = Readonly<{
	channel: string;
}>;

type Result<T extends ConfigWithChannel> = Readonly<{
	copyConfig: T | undefined;
	socialConfigs: readonly T[];
}>;

export function splitShareButtonConfigsByCopy<T extends ConfigWithChannel>(buttonConfigs: readonly T[]): Result<T> {
	let copyConfig: T | undefined;
	const socialConfigs: T[] = [];

	for (const buttonConfig of buttonConfigs) {
		if (buttonConfig.channel === 'copy') {
			if (!copyConfig) {
				copyConfig = buttonConfig;
			}
		} else {
			socialConfigs.push(buttonConfig);
		}
	}

	return { copyConfig, socialConfigs };
}
